import React from 'react';

import { ListingsTemplate } from '../templates';
import { ListingListProvider } from '../useListingList';

export function ListingsPage() {
  return (
    <ListingListProvider key="listings">
      <ListingsTemplate fontaineShell />
    </ListingListProvider>
  );
}
